import React from "react";
import { TouchableOpacity } from "react-native";

import Svg, {
  Path,
  G,
  Defs,
  Circle,
  LinearGradient,
  Stop,
} from "react-native-svg";

import { isWeb } from "../../../../../helpers/utils";

import { uniqueId } from "lodash";

export default function MariTalkingIcon(props) {
  const filterId = "filter0_d_MariTalkingIcon" + uniqueId();
  const gradientId = "paint0_linear_MariTalkingIcon" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";
  const gradientUrl = "url(#" + gradientId + ")";
  const width = props.width || 66;
  const height = props.height || 66;

  return (
    <TouchableOpacity {...props}>
      <Svg
        width={width} 
        height={height} 
        preserveAspectRatio="xMinYMin slice" 
        viewBox="0 0 66 66"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G filter={filterUrl}>
          <Circle cx="33" cy="29" r="28" fill={gradientUrl} />
          <Path
            d="M21.3945 30.1678C22.9057 30.1678 24.1308 28.9427 24.1308 27.4315C24.1308 25.9203 22.9057 24.6953 21.3945 24.6953C19.8833 24.6953 18.6582 25.9203 18.6582 27.4315C18.6582 28.9427 19.8833 30.1678 21.3945 30.1678Z"
            fill="#243251"
          />
          <Path
            opacity="0.61"
            d="M20.8539 27.0824C21.2395 27.0824 21.5521 26.7699 21.5521 26.3843C21.5521 25.9987 21.2395 25.6862 20.8539 25.6862C20.4683 25.6862 20.1558 25.9987 20.1558 26.3843C20.1558 26.7699 20.4683 27.0824 20.8539 27.0824Z"
            fill="white"
          />
          <Path
            d="M17.3857 20.8216C18.4636 20.0162 19.74 19.5184 21.0786 19.3816C22.4173 19.2448 23.7679 19.4739 24.9865 20.0447"
            stroke="#243251"
            strokeWidth="0.966"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M44.1181 31.0575C45.6293 31.0575 46.8544 29.8324 46.8544 28.3212C46.8544 26.81 45.6293 25.5849 44.1181 25.5849C42.6069 25.5849 41.3818 26.81 41.3818 28.3212C41.3818 29.8324 42.6069 31.0575 44.1181 31.0575Z"
            fill="#243251"
          />
          <Path
            opacity="0.61"
            d="M43.4647 27.9609C43.8503 27.9609 44.1629 27.6483 44.1629 27.2627C44.1629 26.8771 43.8503 26.5646 43.4647 26.5646C43.0792 26.5646 42.7666 26.8771 42.7666 27.2627C42.7666 27.6483 43.0792 27.9609 43.4647 27.9609Z"
            fill="white"
          />
          <Path
            d="M40.6724 20.7091C41.0553 20.1964 41.5606 19.7878 42.1421 19.5208C42.7236 19.2537 43.3628 19.1367 44.0012 19.1804C44.6396 19.2241 45.2569 19.4271 45.7966 19.7708C46.3363 20.1146 46.7813 20.5882 47.0908 21.1483"
            stroke="#243251"
            strokeWidth="0.966"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M39.1568 39.6197C36.9635 40.2513 30.4432 41.8216 26.4662 39.5941C26.1931 39.4405 25.8688 39.6795 25.9286 39.9867C26.4833 42.7092 28.8815 45.406 32.8158 45.5767C37.1512 45.7644 39.3787 41.7277 39.7115 40.0123C39.7969 39.6112 39.5494 39.5088 39.1568 39.6197Z"
            fill="#243251"
          />
        </G>
        <Defs>
          {isWeb ? (
            <filter
              id={filterId}
              x="0"
              y="0"
              width="66"
              height="66"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          ) : null}
          <LinearGradient
            id={gradientId}
            x1="5"
            y1="1"
            x2="44.4204"
            y2="45.7669"
            gradientUnits="userSpaceOnUse"
          >
            <Stop offset="0.374593" stopColor="#00FFD1" />
            <Stop offset="1" stopColor="#239C9D" />
          </LinearGradient>
        </Defs>
      </Svg>
    </TouchableOpacity>
  );
}
